import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap-5';

export const propertySettingsPropTypes = {
  createdAt: PropTypes.string,
  hideInternally: PropTypes.bool,
  showHideInternallyForStatuses: PropTypes.arrayOf(PropTypes.number).isRequired,
  updatedAt: PropTypes.string,
  syndication: PropTypes.bool.isRequired
};

class PropertySettings extends React.Component {
  static propTypes = {
    ...propertySettingsPropTypes
  }

  render() {
    return (
      <div className="property-settings">
        {this.renderHeader()}
        {this.renderSyndicationHiddenField()}
        {this.renderHideInternallyField()}
      </div>
    );
  }

  renderHeader() {
    const showTimeStamps = (this.props.createdAt && this.props.updatedAt);
    return (
      <Row className="align-items-end mb-4">
        <Col>
          <h5 className="d-flex align-items-center gap-1">
            <i className="fas fa-cog fa-fw text-primary"/>
            Settings
          </h5>
        </Col>
        {showTimeStamps &&
          <Col xs="auto">
            <div className="text-muted" name="timeLabels">
              <div>
                <small>
                  Created {this.props.createdAt}
                </small>
              </div>
              <div>
                <small>
                  Updated {this.props.updatedAt}
                </small>
              </div>
            </div>
          </Col>
        }
      </Row>
    );
  }

  renderSyndicationHiddenField() {
    return (
      <input name="property[manage_syndication]" type="hidden" value={this.props.syndication ? '1' : '0'} />
    );
  }

  renderHideInternallyField() {
    if (this.props.hideInternally === null) return;

    return (
      <input name="property[hide_internally]" type="hidden" value={this.props.hideInternally ? '1' : '0'} />
    );
  }
}

export default PropertySettings;
